namespace $.$$ {
	export class $shm_showcase_demo_file_drop extends $.$shm_showcase_demo_file_drop {
		selected() { return this.files().map( file => file.name ).join( '\n' ) || 'Файл не выбран' }
	}
}
